import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Checkbox,
    Tooltip, TextField, FormControlLabel, Radio, Modal, Button, IconButton, Tabs, Tab,
    InputAdornment, Switch,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    RadioGroup,
    Autocomplete,
    CircularProgress
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { DateTime } from 'luxon';
import { AmountFormat, ContentInTooltip, formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../Utility/Constants';
import { Colors } from '../../../Styles/Colors';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';

const tableHeadSx = {
    backgroundColor: '#f5f5f5',
    fontSize: '0.85vw',
    whiteSpace: 'nowrap',
};

const CreditPaymentPopup = ({ open, onClose, patientData, getApiUrl, postApiUrl, type, errorMessage, successMessage, Editaccess, isForBulkPayment, PatientDataList, BulkSelectionList = [] , ClearBulkSelection}) => {

    const [value, setValue] = useState('one');
    const [searchDate, setSearchDate] = useState(null);
    const [historytData, setHistorytData] = useState([]);
    const [PreAuthAmount, setPreAuthAmount] = useState(0);
    const [payableAmount, setPayableAmount] = useState('');
    const [receivableAmt, setReceivableAmt] = useState('');
    const [totalPayableAmt, setTotalPayableAmt] = useState(0);
    const [balanceAmount, setBalanceAmount] = useState('');
    const [paymentData, setPaymentData] = useState([]);
    const [postLoad, setPostLoad] = useState(false);
    const [amountDetail, setAmountDetail] = useState({});
    const [dupliPaymentData, setDupliPaymentData] = useState('');
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [pharmaBillDetails, setPharmaBillDetails] = useState([])
    const [otBillDetails, setOtBillDetails] = useState([])
    const [openDateSearch, setOpenDateSearch] = useState(false);
    const [bankDetails, setBankDetails] = useState([]);
    const [bankNameList, setBankNameList] = useState([]);
    const [accountNoList, setAccountNoList] = useState([]);
    const [states, setStates] = useState({
        disallowanceAmt: '', tdsAmount: '', hospitalConcess: '',
        payerBankName: '', payerAccountNo: '', transId: '', transDate: new Date(),
        receiverBankName: '', receiverAccountNo: '', transDateOpen: false,
        chequeNo: '', chequeDate: new Date(), chequeOpen: false,
        isCash: false, isCard: false, isUPI: false, isBank: false, isCheque: false,
        cash_amt: '', card_amt: '', card_no: '', upi_amt: '', upi_no: '', bank_amt: '',
        cheque_amt: '', selectPayer: null, comments: '', bank_no: '', cheque_no: '',
        pharamacyList: [], show_pharmacy_bill: false, include_pharmacy: false,
    });
    const [BulkDataStates , setBulkDataStates] = useState({
        PatientList : PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id))),
        company_name: PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id)))[0]?.company_name,
        totalPayableAmt: PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id))).reduce((sum, item) => sum + (+item?.pending_amount || 0), 0),
        OpBillList: [],
        PharmaBillList: [],
        OTBillList: [],
    })
    const [isLoading, setIsLoader] = useState(false)
    const LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
    const ShowPHBills = JSON.parse(localGetItem("Show_PH_Bills_In_Credit_Settle"))

    const hasAccess = JSON.parse(localGetItem('is_transaction_number_mandatory')) ?? JSON.parse(localGetItem('loggedInUserInfo'))?.is_transaction_number_mandatory

    useEffect(() => {
        let isMounted = true;
        setStates((prev) => ({
            ...prev,
            selectPayer: type === "Insurance credit" ? 'Insurance' : 'Corporate',
        }))
        getBankDetailsData();
        if (open && getApiUrl && !isForBulkPayment) {
            getPaymentDetails(null, isMounted)
        }
        if (LoggedUserData?.module_name === 'front_office') {
            setStates((prev) => ({
                ...prev,
                pharamacyList: LoggedUserData?.pharmacy_data ? JSON.parse(JSON.stringify((LoggedUserData?.pharmacy_data))) : [],
                include_pharmacy: ShowPHBills ? (LoggedUserData?.pharmacy_data ? JSON.parse(JSON.stringify((LoggedUserData?.pharmacy_data)))[0]?.pharmacy_id : true) : false
            }))
        }
        setBulkDataStates((prev) => ({
            ...prev,
            PatientList: PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id))),
            company_name: PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id)))[0]?.company_name,
            employer_id: PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id)))[0]?.employer_id,
            totalPayableAmt: PatientDataList?.filter((list) => (BulkSelectionList?.includes(list?.id))).reduce((sum, item) => sum + (+item?.pending_amount || 0), 0)
        }))
        return () => {
            isMounted = false;
        };
    }, [open, getApiUrl]);

    useEffect(() => {
        if (isForBulkPayment && BulkDataStates?.PatientList?.length) {
            getBulkCorpData();
        }
    }, [BulkDataStates?.PatientList]);

    const getPaymentDetails = (type, isMounted = true) => {
        setIsLoader(true)
        const selectedType = type || value;
        const billType = selectedType === 'one' ? 'outstanding' : selectedType === 'two' ? 'history' : null;
        try {
            RestAPIService.getAll(`${getApiUrl}&bill_type=${billType}`)
                .then((response) => {
                    if (!isMounted) return;
                    const data = response?.data?.fo_data || [];
                    if (response?.data?.status === 'success') {
                        setIsLoader(false)
                        if (billType === 'outstanding') {
                            setIntialBillDetails(data, false, (response.data?.ph_data || []), (response.data?.ot_data || []) || []);
                            setPharmaBillDetails(response.data?.ph_data || [])
                            setOtBillDetails(response.data?.ot_bills || [])
                            setDupliPaymentData(data);
                            setPreAuthAmount(response.data?.policy_amount || 0)
                        }
                    }
                })
                .catch((error) => {
                    setIsLoader(false)
                    if (!isMounted) return;
                    const errMsg = error?.response?.data?.message || error?.message;
                    errorMessage(errMsg);
                });
        } catch (error) {
            setIsLoader(false)
            if (!isMounted) return;
            errorMessage(error.message);
        }
    };

    const getBankDetailsData = () => {
        try {
            setBankDetails([]);

            RestAPIService.getAll(`${Serviceurls.GET_MASTER_BANK_DATA}`)
                .then(response => {
                    if (response.data.status === "success") {
                        const apiData = response.data?.data || [];
                        setBankDetails(apiData)
                        const bankNameList = apiData.map((item) => item?.bank_name);
                        const accountNoList = apiData.map((item) => item?.bank_account_number);
                        setBankNameList(bankNameList);
                        setAccountNoList(accountNoList);
                    }
                })
                .catch(error => {
                    const errMsg = error?.response?.data?.message || error?.message;
                    errorMessage(errMsg);
                });
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const getBulkCorpData = () => {
        try {
            const appointmentIds = BulkDataStates?.PatientList
                ?.map(item => item?.appointment_id)
                ?.filter(id => id !== undefined && id !== null && id !== "")
                ?.join(",");

            const ipAdmissionIds = BulkDataStates?.PatientList
                ?.map(item => item?.ip_admission_id)
                ?.filter(id => id !== undefined && id !== null && id !== "")
                ?.join(",");

            const Ph_bill_ids = BulkDataStates?.PatientList
                ?.filter(item => item?.pharmacy_id)
                ?.map(item => item?.id)
                ?.filter(id => id !== undefined && id !== null && id !== "")
                ?.join(",");    

            const QueryParams = `?appointment_id=${appointmentIds}&ip_admission_id=${ipAdmissionIds}&ph_bill_id=${Ph_bill_ids}&company_name=${encodeURIComponent(BulkDataStates?.company_name)}&bill_type=outstanding`;
            RestAPIService.getAll(`${Serviceurls.CORPORATE_BILL_GET}${QueryParams}`)
                .then(response => {
                    if (response.data.status === "success") {
                        setBulkDataStates((prev) => ({
                            ...prev,
                            OpBillList : response.data?.fo_data || [],
                            PharmaBillList : response.data?.ph_data || [],
                            OTBillList : response.data?.ot_data || [],
                        }))
                    }
                })
                .catch(error => {
                    const errMsg = error?.response?.data?.message || error?.message;
                    errorMessage(errMsg);
                });
        } catch (error) {
            errorMessage(error.message)
        }
    };

    const setIntialBillDetails = (Data, ModuleCheck = false, pharmacyBills = pharmaBillDetails, Ot_bills = otBillDetails) => {
        try {
            let totalOutstandingAmount = 0;
            let totalPaidAmount = 0;
            let totalBillingAmount = 0;
            let updatedData = [];

            // Process Main Bills
            for (let i = 0; i < Data.length; i++) {
                let bill = Data[i];
                let totalBillOutstanding = 0;
                let totalBillAmount = 0;
                let services = [];
                if (bill?.line_item) {
                    bill['bill_items'] = bill?.line_item
                }
                if (bill.bill_items) {
                    for (let j = 0; j < bill.bill_items.length; j++) {
                        let service = bill.bill_items[j];
                        services.push({
                            ...service,
                            bill_outstanding_amount: service?.outstanding_amount,
                            deduct_amount: 0,
                        });
                    }
                    totalOutstandingAmount += bill?.outstanding_amount;
                    totalPaidAmount += bill?.received_amount;
                    totalBillingAmount += bill?.net_amount;
                    totalBillOutstanding += bill?.outstanding_amount;
                    totalBillAmount += bill?.net_amount;
                }

                updatedData.push({
                    ...bill,
                    index: i,
                    New_outstanding_amount: bill?.outstanding_amount,
                    bill_amount: totalBillAmount,
                    deduct_amount: 0,
                    bill_selected: true,
                    services,
                });
            }

            // Process pharmacy bills
            let finalPharmacyBills = [];

            if (states?.include_pharmacy && ShowPHBills) {
                if (states?.pharamacyList?.length > 0) {
                    for (let i = 0; i < pharmacyBills.length; i++) {
                        if (pharmacyBills[i]?.pharmacy_id === states?.include_pharmacy) {
                            finalPharmacyBills.push({
                                ...pharmacyBills[i],
                                bill_outstanding_amount: pharmacyBills[i]?.outstanding_amount || 0,
                                index: updatedData.length + i,
                                deduct_amount: 0,
                                bill_amount: pharmacyBills[i]?.net_amount || 0,
                                bill_selected: true,
                                bill_type: "pharmacy"
                            });
                            totalOutstandingAmount += pharmacyBills[i]?.outstanding_amount;
                            totalBillingAmount += pharmacyBills[i]?.net_amount;
                            totalPaidAmount += pharmacyBills[i]?.received_amount;
                        }
                    }
                } else {
                    for (let i = 0; i < pharmacyBills.length; i++) {
                        finalPharmacyBills.push({
                            ...pharmacyBills[i],
                            index: updatedData.length + i,
                            deduct_amount: 0,
                            bill_amount: pharmacyBills[i]?.net_amount || 0,
                            bill_outstanding_amount: pharmacyBills[i]?.outstanding_amount || 0,
                            bill_selected: true,
                            bill_type: "pharmacy"
                        });
                        totalOutstandingAmount += pharmacyBills[i]?.outstanding_amount;
                        totalBillingAmount += pharmacyBills[i]?.net_amount;
                        totalPaidAmount += pharmacyBills[i]?.received_amount;
                    }
                }
                updatedData.push(...finalPharmacyBills);
            };

            // Process ot bills
            if (Ot_bills?.length) {
                let finalOtBills = [];
                for (let i = 0; i < Ot_bills.length; i++) {
                    finalOtBills.push({
                        ...Ot_bills[i],
                        index: updatedData.length + i,
                        deduct_amount: 0,
                        bill_amount: Ot_bills[i]?.total_net_amount || 0,
                        bill_outstanding_amount: Ot_bills[i]?.outstanding_amount || 0,
                        bill_selected: true,
                        bill_type: "ot"
                    });
                    totalOutstandingAmount += Ot_bills[i]?.outstanding_amount;
                    totalBillingAmount += Ot_bills[i]?.total_net_amount;
                    totalPaidAmount += Ot_bills[i]?.received_amount;
                }
                updatedData.push(...finalOtBills);
            };

            // Final state updates
            setPaymentData(updatedData || []);
            setStates(prev => ({
                ...prev,
                getBillsFlag: false,
                ...(ModuleCheck && { receivable_amt: "" })
            }));
        } catch (error) {
            errorMessage(error?.message);
        }
    };

    useEffect(() => {
        if (dupliPaymentData?.length || pharmaBillDetails?.length) {
            setIntialBillDetails(dupliPaymentData, true)
        }
    }, [states?.include_pharmacy])

    const handleClose = (callAPI) => {
        onClose(callAPI);
        setStates((prev) => ({
            ...prev,
            disallowanceAmt: '', tdsAmount: '', hospitalConcess: '',
            payerBankName: '', payerAccountNo: '', transId: '', transDate: new Date(),
            receiverBankName: '', receiverAccountNo: '', transDateOpen: false,
            chequeNo: '', chequeDate: new Date(), chequeOpen: false,
            isCash: false, isCard: false, isUPI: false, isBank: false, isCheque: false,
            cash_amt: '', card_amt: '', card_no: '', upi_amt: '', upi_no: '', bank_amt: '',
            bank_no: '', cheque_amt: '', cheque_no: '', selectPayer: null,
            pharamacyList: [], show_pharmacy_bill: false, comments: '', include_pharmacy: false
        }));
        setPaymentData([])
        setDupliPaymentData('')
        setPayableAmount('');
        setBalanceAmount('');
        setTotalPayableAmt(0);
        setPreAuthAmount(0);
        setReceivableAmt('');
        setPaymentMethod(null)
    };

    const handleClear = () => {
        setSearchDate(null);
        setPayableAmount('');
        setBalanceAmount('');
        setTotalPayableAmt(0);
        setPreAuthAmount(0);
        setReceivableAmt('');
        setPaymentMethod(null)
        setStates((prev) => ({
            ...prev,
            disallowanceAmt: '', tdsAmount: '',
            hospitalConcess: '', payerBankName: '',
            payerAccountNo: '', transId: '', transDate: new Date(),
            receiverBankName: '', receiverAccountNo: '', transDateOpen: false,
            chequeNo: '', chequeDate: new Date(), chequeOpen: false,
            isCash: false, isCard: false, isUPI: false, isBank: false, isCheque: false,
            cash_amt: '', card_amt: '', card_no: '', upi_amt: '', upi_no: '', bank_amt: '',
            bank_no: '', cheque_amt: '', cheque_no: '', comments: '',
        }));
    };

    const renderDatePicker = () => {
        return value !== 'one' ? (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    open={openDateSearch}
                    onOpen={() => setOpenDateSearch(true)}
                    onClose={() => setOpenDateSearch(false)}
                    inputFormat='dd-MM-yyyy'
                    label="Select Date"
                    value={searchDate}
                    maxDate={new Date()}
                    onChange={(newValue) => setSearchDate(newValue)}
                    renderInput={(params) => (
                        <TextField
                            onKeyDown={(e) => e.preventDefault()}
                            autoComplete="off"
                            size="small"
                            sx={{ width: '12vw', mr: '1vw' }}
                            {...params}
                            onClick={() => setOpenDateSearch(true)}
                        />
                    )}
                />
            </LocalizationProvider>
        ) : null;
    };

    const inputTextBox = (names, value, label, width, mr, disable = false) => {
        try {
            return (
                <TextField
                    autoComplete='off'
                    key={names}
                    size="small"
                    sx={{ width: width, mr: mr }}
                    disabled={disable || (names === 'tdsAmount' && type !== 'Corporate credit' && !isForBulkPayment) || names === 'disallowanceAmt' || names === 'receivableAmt'}
                    label={label}
                    name={names}
                    value={value}
                    onChange={(e) => onChangeHandler(e, names)}
                    inputProps={{ emed_tid: names }}
                />
            );
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const inputAutoComplete = (name, value, options, label, width, mr = 0, disable = false, linkField = null, dataList = []) => {
        return (
            <Autocomplete
                freeSolo
                size="small"
                options={options || []}
                getOptionLabel={(option) =>
                    typeof option === "string" ? option : name === "receiverBankName" ? option?.bank_name || "" : option?.bank_account_number || ""
                }
                value={value || ""}
                disabled={disable}
                onChange={(e, newValue) => {
                    if (typeof newValue === "string") {
                        const match = dataList?.find((item) => {
                            if (name === "receiverBankName") return item?.bank_name === newValue;
                            if (name === "receiverAccountNo") return item?.bank_account_number === newValue;
                        });

                        setStates((prev) => ({
                            ...prev,
                            [name]: newValue,
                            ...(linkField && match && {
                                [linkField]: name === "receiverBankName" ? match?.bank_account_number : match?.bank_name
                            })
                        }));
                    }
                }}
                onInputChange={(e, newInputValue) => {
                    setStates((prev) => ({
                        ...prev,
                        [name]: newInputValue
                    }));
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        size="small"
                        autoComplete="off"
                        sx={{ width: width, mr: mr }}
                        inputProps={{
                            ...params.inputProps,
                            emed_tid: name,
                        }}
                    />
                )}
            />
        );
    };

    const inputDatePicker = (names, value, label, width, mr, disable, popupState) => {
        try {
            return (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        open={states?.[popupState]}
                        onOpen={() => { handleDatePickerPopup(popupState, true) }}
                        onClose={() => { handleDatePickerPopup(popupState, false) }}
                        inputFormat='dd-MM-yyyy'
                        label={label}
                        name={names}
                        value={value}
                        maxDate={new Date()}
                        onChange={(newDate) => {
                            const dateValue = newDate?.$d ? newDate?.$d : newDate;
                            setStates((prev) => ({
                                ...prev,
                                [names]: dateValue,
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                onKeyDown={(e) => e.preventDefault()}
                                autoComplete="off"
                                size="small"
                                sx={{ width: width, mr: mr }}
                                disabled={disable}
                                {...params}
                                onClick={() => handleDatePickerPopup(popupState, true)}
                            />
                        )}
                    />
                </LocalizationProvider>
            );
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const handleDatePickerPopup = (stateKey, open = false) => {
        setStates((prev) => ({
            ...prev,
            [stateKey]: open ? true : false,
        }));
    };

    const onChangeHandler = (e, names) => {
        try {
            const value = e.target.value;
            let totalAmt = 0;
            paymentData?.forEach(element => {
                if (element?.is_checked) {
                    totalAmt = CommonValidation.formatAmount(totalAmt + element?.outstanding_amount);
                }
            });
            const maxReceivableOrDisallowance = (+totalAmt - +states?.tdsAmount)
            switch (names) {
                case 'payableAmount': {
                    if ((CommonValidation.numberOnly(value) && +value <= (isForBulkPayment ? +BulkDataStates?.totalPayableAmt : +totalAmt)) || value === '') {
                        setPayableAmount(value);

                        let disAllowance = +totalAmt - (+value);
                        let tdsAmount = (+value * 0.10);
                        let receivable = +value - tdsAmount;
                        receivable = receivable < 0 ? 0 : receivable;

                        setStates((prev) => ({
                            ...prev,
                            tdsAmount: states?.selectPayer === "Patient" || type === 'Corporate credit' ? "" : tdsAmount.toFixed(2),
                            disallowanceAmt: states?.selectPayer === "Patient" || type === 'Corporate credit' ? 0 : disAllowance.toFixed(2)
                        }));
                        setReceivableAmt(type === 'Corporate credit' ? +value : receivable.toFixed(2));

                        if (value !== '') {
                            setBalanceAmount(+value !== 0 ? CommonValidation.formatAmount(totalAmt - +value) : 0);
                        }
                        setPaymentMethod(null)
                        let Totalvalue = states?.selectPayer === 'Patient' || type === 'Corporate credit' ? +value : +totalPayableAmt;
                        CalculateDeductAmt(paymentData, Totalvalue, true);
                    }
                    break;
                }

                case 'receivableAmt': {
                    const claimAmt = +payableAmount;
                    const tdsAmt = claimAmt * 0.10;
                    const claimCap = claimAmt - tdsAmt;

                    let receivable = +value;
                    let disallowance = claimCap - receivable;

                    disallowance = +disallowance.toFixed(2);
                    receivable = +receivable.toFixed(2);

                    if (
                        CommonValidation.NumberWithDot(value) && receivable >= 0 && disallowance >= 0 && receivable <= claimCap
                    ) {
                        setReceivableAmt(receivable.toFixed(2));
                        setStates((prev) => ({
                            ...prev,
                            disallowanceAmt: disallowance.toFixed(2),
                            tdsAmount: (isForBulkPayment || states?.selectPayer === 'Patient' || type === 'Corporate credit'  ) ? (+prev?.tdsAmount ? prev?.tdsAmount : "") : tdsAmt.toFixed(2),
                            tDSpercentage : isForBulkPayment ? CommonValidation.getDiscountPercentage(prev?.tdsAmount, BulkDataStates?.totalPayableAmt): 0
                        }));
                    }
                    break;
                }

                case 'disallowanceAmt': {
                    const disallowance = value ? +value : 0;
                    if ((CommonValidation.NumberWithDot(value) && disallowance <= (maxReceivableOrDisallowance)) || value === '') {
                        let payableAmt = +totalAmt - (+value + +states?.tdsAmount)
                        setPayableAmount(payableAmt);
                        setStates((prev) => ({
                            ...prev,
                            disallowanceAmt: value,
                        }));
                    }
                    break;
                }

                case 'tdsAmount': {
                    const tds = value ? +value : 0;
                    if ((CommonValidation.NumberWithDot(value) && tds <= (isForBulkPayment ? BulkDataStates?.totalPayableAmt : (+totalAmt - +payableAmount))) || value === '') {
                        setStates((prev) => ({
                            ...prev,
                            tdsAmount: value,
                            tDSpercentage : isForBulkPayment ? CommonValidation.getDiscountPercentage(+value, BulkDataStates?.totalPayableAmt) : 0
                        }));
                        if((type === 'Corporate credit' && states?.selectPayer !== "Patient")){
                            let Totalvalue = (+value + +receivableAmt)
                            CalculateDeductAmt(paymentData, Totalvalue, true);
                        }
                    }
                    break;
                }

                case 'payerBankName':
                case 'receiverBankName':
                    if ((CommonValidation.alphabetOnly(value) && value.length <= 60) || value === '') {
                        setStates((prev) => ({ ...prev, [names]: value }));
                    }
                    break;

                case 'payerAccountNo':
                case 'receiverAccountNo':
                case 'chequeNo':
                    if ((CommonValidation.numberOnly(value) && value.length <= 20) || value === '') {
                        setStates((prev) => ({ ...prev, [names]: value }));
                    }
                    break;

                case 'transId':
                    if ((CommonValidation.ALPHA_NUMARIC(value) && value.length <= 30) || value === '') {
                        setStates((prev) => ({ ...prev, transId: value }));
                    }
                    break;

                default:
                    console.warn("Unhandled input name:", names);
                    break;
            }
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const CalculateDeductAmt = (BillData = paymentData, AMT = 0, fromPayable = false) => {
        try {
            let remainingAmount = (fromPayable && !AMT) ? 0 : parseFloat((AMT && AMT != 0) ? +AMT : (balanceAmount ? +balanceAmount : 0)) || 0;
            let totalOutstandingAmount = 0;
            let totalPaidAmount = 0;
            let totalBillingAmount = 0;

            let updatedList = [];

            for (let i = 0; i < BillData.length; i++) {
                let bill = BillData[i];

                if (!bill.is_checked) {
                    let updatedServices = bill?.bill_items ? bill?.bill_items.map(service => ({
                        ...service,
                        deduct_amount: 0
                    })) : [];

                    updatedList.push({
                        ...bill,
                        services: updatedServices,
                        deduct_amount: 0
                    });
                    continue;
                }

                let updatedServices = [];
                let outstandingSum = 0;
                let receiptSum = 0;

                if (bill.bill_type === "pharmacy") {
                    let billDeduct = Math.min(bill?.outstanding_amount, remainingAmount);
                    remainingAmount -= billDeduct;

                    updatedList.push({
                        ...bill,
                        deduct_amount: +billDeduct.toFixed(2),
                        is_checked: true,
                    });
                    totalOutstandingAmount += bill?.outstanding_amount || 0;
                    totalPaidAmount += bill.received_amount || 0;
                    totalBillingAmount += bill.net_amount || 0;

                } else if (bill.bill_type === "ot") {
                    let billDeduct = Math.min(bill.bill_outstanding_amount, remainingAmount);
                    remainingAmount -= billDeduct;

                    updatedList.push({
                        ...bill,
                        deduct_amount: +billDeduct.toFixed(2),
                        is_checked: true,
                    });
                    totalOutstandingAmount += bill.bill_outstanding_amount || 0;
                    totalPaidAmount += bill.received_amount || 0;
                    totalBillingAmount += bill.net_amount || 0;

                } else {
                    if (bill.services) {
                        let tempRemainingAmt = remainingAmount
                        for (let j = 0; j < bill.services.length; j++) {
                            let service = bill.services[j];
                            let deduct = 0;
                            if (tempRemainingAmt > 0) {
                                deduct = Math.min(service?.bill_outstanding_amount || service?.outstanding_amount || 0, tempRemainingAmt);
                                tempRemainingAmt -= deduct;
                            }

                            let updatedService = {
                                ...service,
                                deduct_amount: +deduct.toFixed(2)
                            };

                            updatedServices.push(updatedService);
                            receiptSum += updatedService.deduct_amount;
                        }
                        outstandingSum = BillData[i].New_outstanding_amount
                    }
                    let deduct = 0;
                    if (remainingAmount > 0) {
                        deduct = Math.min(bill.outstanding_amount || 0, remainingAmount);
                        remainingAmount -= deduct;
                    }
                    totalOutstandingAmount += BillData[i].New_outstanding_amount || 0;
                    totalPaidAmount += bill.received_amount || 0;
                    totalBillingAmount += bill.net_amount || 0;

                    updatedList.push({
                        ...bill,
                        services: updatedServices,
                        deduct_amount: deduct,
                    });
                }
            }
            setPaymentData(updatedList);
        }
        catch (error) {
            errorMessage(error?.message)
        }
    };

    const handleTabChange = (e, newValue) => {
        setValue(newValue);
        setSearchDate(null);

        let isMounted = true;
        getPaymentDetails(newValue, isMounted);

        return () => {
            isMounted = false;
        };
    };

    const PaymentCheckBox = (e, key) => {
        try {
            let checked = e.target.checked;
            if (!checked && states?.selectPayer === "Patient") {
                let clearFields = {};
                if (key === "isCard") {
                    clearFields = { card_amt: '', card_no: '' };
                } else if (key === "isUPI") {
                    clearFields = { upi_amt: '', upi_no: '' };
                } else if (key === "isBank") {
                    clearFields = { bank_amt: '', bank_no: '' };
                } else if (key === "isCheque") {
                    clearFields = { cheque_amt: '', cheque_no: '' };
                } else if (key === "isCash") {
                    clearFields = { cash_amt: '' };
                }
                setStates((prev) => ({ ...prev, [key]: checked, ...clearFields }));
            } else {
                setStates((prev) => ({ ...prev, [key]: checked }));
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const handleCheckBox = (e, index = null) => {
        const checked = e.target.checked;
        let updatedBalanceAmount = 0;

        const updatedPaymentData = paymentData.map((item, i) => {
            if (index !== null) {
                if (i === index) {
                    const updatedItem = {
                        ...item,
                        is_checked: checked,
                        deduct_amount: checked ? +item.outstanding_amount : 0
                    };
                    if (checked) updatedBalanceAmount += item.outstanding_amount;
                    return updatedItem;
                }
                return item;
            } else {
                const updatedItem = {
                    ...item,
                    is_checked: checked,
                    deduct_amount: checked ? +item.outstanding_amount : 0
                };
                if (checked) updatedBalanceAmount += item.outstanding_amount;
                return updatedItem;
            }
        });

        let totalPayableAmount = updatedPaymentData?.reduce((sum, item) => sum + (item.is_checked ? (+item?.outstanding_amount  || 0) : 0), 0)
        setTotalPayableAmt(totalPayableAmount || 0);
        setPaymentData(updatedPaymentData);
        setBalanceAmount(totalPayableAmount || 0);
        // setPayableAmount(totalPayableAmount);
        // CalculateDeductAmt(updatedPaymentData, totalPayableAmount);
        setStates((prev) => ({
            ...prev,
            tdsAmount: '',
            disallowanceAmt: "",
        }));
        setReceivableAmt('')
        setPayableAmount('')
    };

    const handleCreditPayment = () => {
        try {
            if (states?.selectPayer === "Patient" && ((+states?.card_amt + +states?.cash_amt + +states?.upi_amt + +states?.bank_amt + +states?.cheque_amt) != +payableAmount)) {
                return errorMessage('Entered Amount is not matched with Receivable Amount');
            }

            if (!paymentMethod && states?.selectPayer !== "Patient") {
                return errorMessage('Please select a payment mode');
            }

            if (hasAccess) {
                if ((states?.isCard && !states.card_no) || (states?.isUPI && !states.upi_no) || (states?.isBank && (!states.bank_no && !states.transId)) || (states?.isCheque && !states.chequeNo)) {
                    return errorMessage('Reference Number is mandatory');
                }
                if (paymentMethod === "isBank" && (!states.transId)) {
                    return errorMessage('Transaction ID is mandatory');
                }
            }
            if ((states?.isCard && states.card_no.length < 4) || (states?.isUPI && states.upi_no.length < 4) || (states?.isBank && (states.bank_no.length < 4 && states.transId.length < 4)) || (states?.isCheque && states.chequeNo.length < 4)) {
                return errorMessage('Reference number must be more than 4 characters.');
            }
            if (paymentMethod === "isBank" && (states.transId.length < 4)) {
                return errorMessage('Transaction ID must be more than 4 characters.');
            }

            let finalAmount = ((states?.selectPayer !== "Patient" ? +receivableAmt : +payableAmount) + (+states?.tdsAmount) + (+states?.disallowanceAmt));
            let paymentDetails = {};
            if (paymentMethod === "isBank") {
                paymentDetails = {
                    payers_bank_name: states.payerBankName,
                    payers_account_no: states.payerAccountNo,
                    transaction_id: states.transId,
                    transaction_date: states.transDate ? DateTime.fromJSDate(states?.transDate)?.toFormat('yyyy-MM-dd') : null,
                    receiver_bank_name: states.receiverBankName,
                    receiver_account_no: states.receiverAccountNo,
                };
            } else if (paymentMethod === "isCheque") {
                paymentDetails = {
                    cheque_no: states.chequeNo,
                    cheque_date: states.chequeDate ? DateTime.fromJSDate(states?.chequeDate)?.toFormat('yyyy-MM-dd') : null,
                };
            }

            let payment = []
            if (states?.isCash) {
                payment.push(1)
            }
            if (states?.isCard) {
                payment.push(2)
            }
            if (states?.isUPI) {
                payment.push(3)
            }
            if (states?.isCheque) {
                payment.push(4)
            }
            if (states?.isBank) {
                payment.push(5)
            }

            let OtherBills = paymentData?.filter((bill) => (bill?.is_checked && bill?.bill_type !== "pharmacy"))?.map((bill) => ({
                "id": bill?.id || null,
                "net_amount": +bill?.net_amount || 0,
                "payment_status": +bill?.deduct_amount === 0 ? 'not paid' : +bill?.outstanding_amount === +bill?.deduct_amount ? 'paid' : "partial",
                "received_amount": +bill?.deduct_amount || 0,
                "credit_type": bill?.credit_type || "",
                "cash_amount": states?.cash_amt ? (+parseFloat(((+states?.cash_amt / finalAmount) * bill?.deduct_amount)) || 0) : 0,
                "card_amount": states?.card_amt ? (+parseFloat(((+states?.card_amt / finalAmount) * bill?.deduct_amount)) || 0) : 0,
                "upi_amount": states?.upi_amt ? (+parseFloat(((+states?.upi_amt / finalAmount) * bill?.deduct_amount)) || 0) : 0,
                "bank_amount": states?.bank_amt ? (+parseFloat(((+states?.bank_amt / finalAmount) * bill?.deduct_amount)) || 0) : 0,
                "cheque_amount": states?.cheque_amt ? (+parseFloat(((+states?.cheque_amt / finalAmount) * bill?.deduct_amount)) || 0) : 0,
                "bill_items": bill?.services?.filter((service) => service?.deduct_amount > 0)?.map((list) => ({
                    "id": list?.id || null,
                    "net_amount": +list?.net_amount || 0,
                    "payment_status": +list?.deduct_amount === 0 ? 'not paid' : +list?.outstanding_amount === +list?.deduct_amount ? 'paid' : "partial",
                    "received_amount": +list?.deduct_amount || 0,
                    "cash_amount": states?.cash_amt ? (+parseFloat(((+states?.cash_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "card_amount": states?.card_amt ? (+parseFloat(((+states?.card_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "upi_amount": states?.upi_amt ? (+parseFloat(((+states?.upi_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "bank_amount": states?.bank_amt ? (+parseFloat(((+states?.bank_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "cheque_amount": states?.cheque_amt ? (+parseFloat(((+states?.cheque_amt / finalAmount) * list?.deduct_amount)) || 0) : 0
                })),
            }))?.filter((bill) => bill.bill_items?.length > 0)
            let ModuleId = ((patientData?.ip_admission_id ? (patientData?.ip_admission_id) : patientData?.appointment_id) || null)
            let data = {
                "bills": OtherBills,
                "ph_bills": paymentData?.filter((bill) => (bill?.is_checked && bill?.bill_type === "pharmacy" && bill?.deduct_amount > 0))?.map((list) => ({
                    "id": list?.id || null,
                    "net_amount": +list?.net_amount || 0,
                    "invoice_number": list?.invoice_number,
                    "invoice_date": list?.invoice_date,
                    "credit_type": list?.credit_type,
                    "payment_status": +list?.deduct_amount === 0 ? 'not paid' : +list?.outstanding_amount === +list?.deduct_amount ? 'paid' : "partial",
                    "received_amount": +list?.deduct_amount || 0,
                    "cash_amount": states?.cash_amt ? (+parseFloat(((+states?.cash_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "card_amount": states?.card_amt ? (+parseFloat(((+states?.card_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "upi_amount": states?.upi_amt ? (+parseFloat(((+states?.upi_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "bank_amount": states?.bank_amt ? (+parseFloat(((+states?.bank_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "cheque_amount": states?.cheque_amt ? (+parseFloat(((+states?.cheque_amt / finalAmount) * list?.deduct_amount)) || 0) : 0
                })),
                "ot_bills": paymentData?.filter((bill) => (bill?.is_checked && bill?.bill_type === "ot" && bill?.deduct_amount > 0))?.map((list) => ({
                    "id": list?.id || null,
                    "net_amount": +list?.net_amount || 0,
                    "invoice_number": list?.invoice_number,
                    "invoice_date": list?.invoice_date,
                    "credit_type": list?.credit_type,
                    "payment_status": +list?.deduct_amount === 0 ? 'not paid' : +list?.outstanding_amount === +list?.deduct_amount ? 'paid' : "partial",
                    "received_amount": +list?.deduct_amount || 0,
                    "cash_amount": states?.cash_amt ? (+parseFloat(((+states?.cash_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "card_amount": states?.card_amt ? (+parseFloat(((+states?.card_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "upi_amount": states?.upi_amt ? (+parseFloat(((+states?.upi_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "bank_amount": states?.bank_amt ? (+parseFloat(((+states?.bank_amt / finalAmount) * list?.deduct_amount)) || 0) : 0,
                    "cheque_amount": states?.cheque_amt ? (+parseFloat(((+states?.cheque_amt / finalAmount) * list?.deduct_amount)) || 0) : 0
                })),
                "receipt": {
                    "payment_mode": payment,
                    "received_amount": finalAmount || 0,
                    "cash_amount": +states?.cash_amt || 0,
                    "card_amount": +states?.card_amt || 0,
                    "upi_amount": +states?.upi_amt || 0,
                    "bank_amount": +states?.bank_amt || 0,
                    "cheque_amount": +states?.cheque_amt || 0,
                    "card_ref_no": states?.card_no || "",
                    "upi_ref_no": states?.upi_no || "",
                    "bank_ref_no": states?.bank_no || "",
                    "cheque_ref_no": states?.cheque_no || "",
                    'dis_allowance_amount': +states?.disallowanceAmt || 0,
                    'tds': +states?.tdsAmount || 0,
                    'comment': states?.comments || '',
                    'claim_amount': (type === 'Corporate credit' && states?.selectPayer !== "Patient") ? ((+payableAmount || 0) + (+states?.tdsAmount || 0)) : (+payableAmount || 0),
                    ...paymentDetails,
                },
                "patient_id": patientData?.patient_id || null,
                "appointment_id": patientData?.module_type === "OP" ? ModuleId : null,
                "ip_admission_id": patientData?.module_type === "IP" ? ModuleId : null,
                'insurance_id': patientData?.insurance_id || null,
                'insurance_company_name': patientData?.insurance_company_name || '',
                'employer_id': patientData?.employer_id || null,
                'company_name': patientData?.company_name || '',
                'credit_type': type === "Corporate credit" ? "Corporate credit" : type,
                'payer': states?.selectPayer || null,
            }
            setIsLoader(true);
            RestAPIService.create(data, postApiUrl)
                .then((response) => {
                    if (response.data.status === 'success') {
                        if(ClearBulkSelection){
                            ClearBulkSelection()
                        }
                        setIsLoader(false);
                        successMessage(response.data.message);
                        handleClose(true);
                    }
                }).catch(e => {
                    setIsLoader(false);
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setIsLoader(false);
            errorMessage(e.message)
        }
    }

    const handleBulkCreditPayment = () => {
        try {

            if ((+receivableAmt + +states?.tdsAmount) !== BulkDataStates?.totalPayableAmt) {
                return errorMessage('Amount not Match.');
            }

            if (hasAccess) {
                if ((states?.isCard && !states.card_no) || (states?.isUPI && !states.upi_no) || (states?.isBank && (!states.bank_no && !states.transId)) || (states?.isCheque && !states.chequeNo)) {
                    return errorMessage('Reference Number is mandatory');
                }
                if (paymentMethod === "isBank" && (!states.transId)) {
                    return errorMessage('Transaction ID is mandatory');
                }
            }
            if ((states?.isCard && states.card_no.length < 4) || (states?.isUPI && states.upi_no.length < 4) || (states?.isBank && (states.bank_no.length < 4 && states.transId.length < 4)) || (states?.isCheque && states.chequeNo.length < 4)) {
                return errorMessage('Reference number must be more than 4 characters.');
            }
            if (paymentMethod === "isBank" && (states.transId.length < 4)) {
                return errorMessage('Transaction ID must be more than 4 characters.');
            }

            let finalAmount = +receivableAmt
            let paymentDetails = {};
            if (paymentMethod === "isBank") {
                paymentDetails = {
                    payers_bank_name: states.payerBankName,
                    payers_account_no: states.payerAccountNo,
                    transaction_id: states.transId,
                    transaction_date: states.transDate ? DateTime.fromJSDate(states?.transDate)?.toFormat('yyyy-MM-dd') : null,
                    receiver_bank_name: states.receiverBankName,
                    receiver_account_no: states.receiverAccountNo,
                };
            } else if (paymentMethod === "isCheque") {
                paymentDetails = {
                    cheque_no: states.chequeNo,
                    cheque_date: states.chequeDate ? DateTime.fromJSDate(states?.chequeDate)?.toFormat('yyyy-MM-dd') : null,
                };
            }

            let payment = []
            if (states?.isCash) {
                payment.push(1)
            }
            if (states?.isCard) {
                payment.push(2)
            }
            if (states?.isUPI) {
                payment.push(3)
            }
            if (states?.isCheque) {
                payment.push(4)
            }
            if (states?.isBank) {
                payment.push(5)
            }

            let OPBills = BulkDataStates?.OpBillList?.filter((bill) => (bill?.appointment_id))?.map((bill) => {
                const total = bill?.outstanding_amount || 0;
                const bill_items = bill?.bill_items?.map((list) => {
                    const ReceivedAmt = list?.outstanding_amount || 0
                    return {
                        id: list?.id || null,
                        net_amount: +list?.net_amount || 0,
                        payment_status: "paid",
                        received_amount: ReceivedAmt,
                        cash_amount: states?.isCash ? ReceivedAmt : 0,
                        card_amount: states?.isCard ? ReceivedAmt : 0,
                        upi_amount: states?.isUPI ? ReceivedAmt : 0,
                        bank_amount: states?.isBank ? ReceivedAmt : 0,
                        cheque_amount: states?.isCheque ? ReceivedAmt : 0,
                    };
                });

                return {
                    id: bill?.id || null,
                    net_amount: +bill?.net_amount || 0,
                    appointment_id: bill?.appointment_id || null,
                    patient_id: bill?.patient_id || null,
                    payment_status: "paid",
                    received_amount: +total || 0,
                    credit_type: bill?.credit_type || "",
                    cash_amount: states?.isCash ? total : 0,
                    card_amount: states?.isCard ? total : 0,
                    upi_amount: states?.isUPI ? total : 0,
                    bank_amount: states?.isBank ? total : 0,
                    cheque_amount: states?.isCheque ? total : 0,
                    bill_items,
                };
            })?.filter((bill) => bill.bill_items?.length > 0);
            let IPBills = BulkDataStates?.OpBillList?.filter((bill) => (bill?.ip_admission_id))?.map((bill) => {
                const total = bill?.outstanding_amount || 0;
                const bill_items = bill?.bill_items?.map((list) => {
                    const ReceivedAmt = list?.outstanding_amount || 0
                    return {
                        id: list?.id || null,
                        net_amount: +list?.net_amount || 0,
                        payment_status: "paid",
                        received_amount: ReceivedAmt,
                        cash_amount: states?.isCash ? ReceivedAmt : 0,
                        card_amount: states?.isCard ? ReceivedAmt : 0,
                        upi_amount: states?.isUPI ? ReceivedAmt : 0,
                        bank_amount: states?.isBank ? ReceivedAmt : 0,
                        cheque_amount: states?.isCheque ? ReceivedAmt : 0,
                    };
                });

                return {
                    id: bill?.id || null,
                    net_amount: +bill?.net_amount || 0,
                    ip_admission_id: bill?.ip_admission_id || null,
                    patient_id: bill?.patient_id || null,
                    payment_status: "paid",
                    received_amount: +total || 0,
                    credit_type: bill?.credit_type || "",
                    cash_amount: states?.isCash ? total : 0,
                    card_amount: states?.isCard ? total : 0,
                    upi_amount: states?.isUPI ? total : 0,
                    bank_amount: states?.isBank ? total : 0,
                    cheque_amount: states?.isCheque ? total : 0,
                    bill_items,
                };
            })?.filter((bill) => bill.bill_items?.length > 0);
            let data = {
                "op_bills": OPBills,
                "ip_bills": IPBills,
                "ph_bills": BulkDataStates?.PharmaBillList?.map((list) => {
                    const total = list?.outstanding_amount || 0;
                    return {
                        "id": list?.id || null,
                        "net_amount": +list?.net_amount || 0,
                        "invoice_number": list?.invoice_number,
                        "invoice_date": list?.invoice_date,
                        "credit_type": list?.credit_type,
                        "payment_status": 'paid',
                        "received_amount": +total || 0,
                        "cash_amount": states?.isCash ? total : 0,
                        "card_amount": states?.isCard ? total : 0,
                        "upi_amount": states?.isUPI ? total : 0,
                        "bank_amount": states?.isBank ? total : 0,
                        "cheque_amount": states?.isCheque ? total : 0,
                        "ip_admission_id": list?.ip_admission_id || null,
                        "appointment_id": list?.appointment_id || null,
                        "patient_id": list?.patient_id || null,
                    }
                }),
                "ot_bills": BulkDataStates?.OTBillList?.map((list) => {
                    const total = list?.outstanding_amount || 0;
                    return {
                        "id": list?.id || null,
                        "net_amount": +list?.net_amount || 0,
                        "invoice_number": list?.invoice_number,
                        "invoice_date": list?.invoice_date,
                        "credit_type": list?.credit_type,
                        "payment_status": 'paid',
                        "received_amount": +total || 0,
                        "cash_amount": states?.isCash ? total : 0,
                        "card_amount": states?.isCard ? total : 0,
                        "upi_amount": states?.isUPI ? total : 0,
                        "bank_amount": states?.isBank ? total : 0,
                        "cheque_amount": states?.isCheque ? total : 0,
                        "ip_admission_id": list?.ip_admission_id || null,
                        "appointment_id": list?.appointment_id || null,
                        "patient_id": list?.patient_id || null,
                    }
                }),
                "receipt": {
                    "payment_mode": payment,
                    "received_amount": +BulkDataStates?.totalPayableAmt || 0,
                    "cash_amount": states?.isCash ? +BulkDataStates?.totalPayableAmt : 0,
                    "card_amount": states?.isCard ? +BulkDataStates?.totalPayableAmt : 0,
                    "upi_amount": states?.isUPI ? +BulkDataStates?.totalPayableAmt : 0,
                    "bank_amount": states?.isBank ? +BulkDataStates?.totalPayableAmt : 0,
                    "cheque_amount": states?.isCheque ? +BulkDataStates?.totalPayableAmt : 0,
                    "card_ref_no": states?.card_no || "",
                    "upi_ref_no": states?.upi_no || "",
                    "bank_ref_no": states?.bank_no || "",
                    "cheque_ref_no": states?.cheque_no || "",
                    'dis_allowance_amount': 0,
                    'tds': +states?.tdsAmount || 0,
                    'comment': states?.comments || '',
                    'claim_amount': 0,
                    ...paymentDetails,
                },
                'employer_id': BulkDataStates?.employer_id || null,
                'company_name': BulkDataStates?.company_name || '',
                'credit_type': "Corporate credit",
            }
            setIsLoader(true);
            RestAPIService.create(data, Serviceurls?.BULK_CROP_CREDIT_SETTLEMENT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setIsLoader(false);
                        successMessage(response.data.message);
                        handleClose(true);
                        if(ClearBulkSelection){
                            ClearBulkSelection()
                        }
                    }
                }).catch(e => {
                    setIsLoader(false);
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setIsLoader(false);
            errorMessage(e.message)
        }
    }

    const onChangePaymentHandler = (e, key) => {
        try {
            let value = e.target.value
            setStates((prev) => {
                switch (key) {
                    case 'cash_amt':
                    case 'card_amt':
                    case 'upi_amt':
                    case 'bank_amt':
                    case 'cheque_amt':
                        if (value === '' || (CommonValidation.numberOnly(value)) && (+payableAmount >= parseFloat(value))) {
                            return { ...prev, [key]: value }
                        } else {
                            return { ...prev }
                        }
                    case 'receivable_amt':
                        if (value === '' || (CommonValidation.numberOnly(value))) {
                            return { ...prev, [key]: value }
                        } else {
                            return { ...prev }
                        }
                    default:
                        return { ...prev, [key]: value }
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const cashTextBox = (key, values, label, Icon) => {
        return (
            <TextField
                size='small'
                sx={{ width: '12.5vw', mt: '0.5rem' }}
                value={values}
                label={`${label} (${CurrencySymbol})`}
                onChange={(e) => onChangePaymentHandler(e, key)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    )
                }}
            />
        )
    }

    const referenceTextBox = (key, values) => {
        return (
            <TextField
                size='small'
                sx={{ width: '13dvw', mt: '0.5rem', ml: states?.selectPayer === "Patient" ? '0.5rem' : 0 }}
                value={values}
                label={`Reference Number${hasAccess ? ' *' : ''}`}
                onChange={(e) => onChangePaymentHandler(e, key)}
                InputProps={{ emed_tid: key }}
            />
        )
    }

    const OutstandingScreen = () => {
        try {
            const isAllBillChecked = paymentData && paymentData?.every((item) => item.is_checked === true);
            let disable = paymentData?.some((item) => item?.is_checked)
            const checkedCount = paymentData.filter(item => item.is_checked).length;
            return (
                <>
                    {(amountDetail?.payment_status === 1 || amountDetail?.payment_status === null || !Editaccess) ? (
                        <Box component="div" height="31vw" p="0.5vw" display="flex" justifyContent="center" alignItems="center">
                            <Typography fontWeight={600}>
                                {!Editaccess ? "No Access To this user" : "No Outstanding Bills To Be Shown"}
                            </Typography>
                        </Box>
                    ) : (
                        <Box component="div" height="31vw" p="0.5vw" display="flex">
                            {/* Left Table Section */}
                            <Box component="div" flex={isForBulkPayment ? 0 : 0.65} border="1px solid lightgray" mr="0.5vw" overflow="auto">
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="10.28%" sx={tableHeadSx}>
                                                <Checkbox
                                                    size="small"
                                                    checked={isAllBillChecked}
                                                    onChange={(e) => handleCheckBox(e, null)}
                                                />
                                            </TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>Bill Date</TableCell>
                                            <TableCell width="16.28%" sx={tableHeadSx}>Bill Details</TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>{`Bill AMT (${CurrencySymbol})`}</TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>{`Paid AMT (${CurrencySymbol})`}</TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>{`Outstanding (${CurrencySymbol})`}</TableCell>
                                            <TableCell width="16.28%" sx={tableHeadSx}>{`Detected (${CurrencySymbol})`}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paymentData?.length > 0 ? (
                                            paymentData.map((item, index) => {
                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ paddingY: "0vw" }}>
                                                            <Checkbox
                                                                size="small"
                                                                checked={item?.is_checked || false}
                                                                onChange={(e) => handleCheckBox(e, index)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>{formatDate(item?.invoice_date)}</TableCell>
                                                        <TableCell>
                                                            <Typography fontSize="0.8vw" fontWeight={600}>
                                                                {item?.invoice_number || 0}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>{AmountFormat(item?.net_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                        <TableCell>{AmountFormat(item?.received_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                        <TableCell>{AmountFormat(item?.outstanding_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                        <TableCell>{AmountFormat(item?.deduct_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={7} align="center">No Records To Be Shown</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>

                            {/* Billing Section */}
                            <Box component="div" flex={isForBulkPayment ? 1 : 0.35} border="1px solid lightgray" overflow="auto">
                                <Box
                                    component="div"
                                    display="flex"
                                    alignItems="center"
                                    sx={{ backgroundColor: Colors.Background }}
                                    p="0.5vw"
                                    borderBottom="1px solid lightgray"
                                >
                                    <Typography fontSize="0.9vw" fontWeight={600}>Billing Information</Typography>
                                </Box>

                                <Box component="div" mt="0.5vw" sx={{ height: "55vh", overflow: "scroll" }}>
                                    <Box component="div" p="0.5vw">
                                        {(states?.selectPayer === "Patient" || type === 'Corporate credit') ? null :
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb="1vw">
                                                <Typography fontWeight={600} fontSize="0.9vw">Pre Auth Amount</Typography>
                                                <Typography fontWeight={600} fontSize="0.9vw">{AmountFormat(PreAuthAmount)}</Typography>
                                            </Box>}
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb="1vw">
                                            <Typography fontWeight={600} fontSize="0.9vw">Total Payable Amount</Typography>
                                            <Typography fontWeight={600} fontSize="0.9vw">{isForBulkPayment ? AmountFormat(BulkDataStates?.totalPayableAmt || 0) : AmountFormat(totalPayableAmt || 0)}</Typography>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.25vw" mt='0.75vw'>
                                            <Typography fontWeight={600} fontSize="0.9vw">{states?.selectPayer === "Patient" || type === 'Corporate credit' ? 'Receivable Amount' : 'Claim Amount'}</Typography>
                                            {inputTextBox('payableAmount', (payableAmount), '', '10vw', '', (isForBulkPayment ? false : (!disable || !states?.selectPayer)))}
                                        </Box>
                                        {states?.selectPayer === "Patient" || type === 'Corporate credit' ? null :
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.25vw">
                                                <Typography fontWeight={600} fontSize="0.9vw">Receivable Amount</Typography>
                                                {inputTextBox('receivableAmt', receivableAmt, '', '10vw', '', (!disable || states?.selectPayer === "Patient" || type === 'Corporate credit' || !states?.selectPayer || !payableAmount))}
                                            </Box>}
                                            {(isForBulkPayment || (type === 'Corporate credit' && states?.selectPayer !== "Patient")) ?
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.25vw">
                                                    <Typography fontWeight={600} fontSize="0.9vw">TDS Amount</Typography>
                                                    {inputTextBox('tdsAmount', states?.tdsAmount, '', '10vw', '', false)}
                                                </Box> : null}
                                        {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.75vw">
                                                <Typography fontWeight={600} fontSize="0.9vw">Received Amount</Typography>
                                                <Typography fontWeight={600} fontSize="0.9vw">{AmountFormat(balanceAmount || 0)}</Typography>
                                            </Box>} */}
                                        {type === 'Corporate credit' || states?.selectPayer === "Patient" ? null :
                                            <Box>
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.5vw">
                                                    <Typography fontWeight={600} fontSize="0.9vw">TDS</Typography>
                                                    {inputTextBox('tdsAmount', states?.tdsAmount, '', '10vw', '', !disable)}
                                                </Box>
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.5vw">
                                                    <Typography fontWeight={600} fontSize="0.9vw">Dis Allowance Amount</Typography>
                                                    {inputTextBox('disallowanceAmt', states?.disallowanceAmt, '', '10vw', '', !disable)}
                                                </Box>
                                            </Box>}
                                    </Box>
                                    {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.5vw">
                                            <Typography fontWeight={600} fontSize="0.9vw">Hospital Concession</Typography>
                                            {inputTextBox('hospitalConcess', states?.hospitalConcess, '', '10vw', '', !disable)}
                                        </Box> */}
                                    <Box component="div" borderTop="1px solid lightgray" p="0.5vw">
                                        <Typography fontWeight={600} fontSize="0.9vw">Select Payment Mode</Typography>
                                        {states?.selectPayer === "Insurance" || states?.selectPayer === "Corporate" ?
                                            <Box>
                                                <RadioGroup
                                                    row
                                                    value={paymentMethod}
                                                    onClick={(e) => {
                                                        const value = e.target.value;
                                                        const amountKeys = {
                                                            isCash: "cash_amt",
                                                            isCard: "card_amt",
                                                            isUPI: "upi_amt",
                                                            isBank: "bank_amt",
                                                            isCheque: "cheque_amt"
                                                        };

                                                        const newState = {
                                                            isCash: false, isCard: false, isUPI: false, isBank: false, isCheque: false,
                                                            cash_amt: 0, card_amt: 0, card_no: '', upi_amt: '', upi_no: '', bank_amt: '',
                                                            bank_no: '', cheque_amt: '', cheque_no: '', payerBankName: '',
                                                            payerAccountNo: '', transId: '', transDate: new Date(),
                                                            receiverBankName: '', receiverAccountNo: '', transDateOpen: false,
                                                            chequeNo: '', chequeDate: new Date()
                                                        };

                                                        if (value === paymentMethod) {
                                                            setPaymentMethod(null);
                                                            setStates((prev) => ({
                                                                ...prev, ...newState,
                                                            }));
                                                        } else {
                                                            setPaymentMethod(value);
                                                            newState[value] = true;
                                                            newState[amountKeys[value]] = ((states?.selectPayer === "Patient" || type === 'Corporate credit' ? +payableAmount : +receivableAmt) + (+states?.tdsAmount) + (+states?.disallowanceAmt));
                                                            setStates((prev) => ({ ...prev, ...newState }));
                                                        }
                                                    }}
                                                >
                                                    <FormControlLabel value="isCash" control={<Radio size="small" />} label="Cash" />
                                                    <FormControlLabel value="isCard" control={<Radio size="small" />} label="Card" />
                                                    <FormControlLabel value="isUPI" control={<Radio size="small" />} label="UPI" />
                                                    <FormControlLabel value="isBank" control={<Radio size="small" />} label="Bank Transfer" />
                                                    <FormControlLabel value="isCheque" control={<Radio size="small" />} label="Cheque" />
                                                </RadioGroup>
                                                <Box component={'div'}>
                                                    {paymentMethod === "isCard" ?
                                                        <Box component={'div'} display={'flex'}>
                                                            {referenceTextBox('card_no', states.card_no)}
                                                        </Box> : null}
                                                    {paymentMethod === "isUPI" ?
                                                        <Box component={'div'} display={'flex'}>
                                                            {referenceTextBox('upi_no', states.upi_no)}
                                                        </Box> : null}
                                                    {paymentMethod === "isBank" ?
                                                        <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5vw', flexWrap: 'wrap', marginTop: "0.5vw" }}>
                                                            {inputTextBox('payerBankName', states?.payerBankName, 'Payers Bank Name', '12.5vw')}
                                                            {inputTextBox('payerAccountNo', states?.payerAccountNo, 'Payers Account No', '12.5vw')}
                                                            {inputTextBox('transId', states?.transId, (`Transaction ID ${hasAccess ? ' *' : ''}`), '12.5vw')}
                                                            {inputDatePicker('transDate', states?.transDate, 'Transaction Date', '12.5vw', '', '', 'transDateopen')}
                                                            {inputAutoComplete("receiverBankName", states?.receiverBankName, bankNameList, "Receiver Bank Name", "12.5vw", '', false, "receiverAccountNo", bankDetails)}
                                                            {inputAutoComplete("receiverAccountNo", states?.receiverAccountNo, accountNoList, "Receiver Account No", "12.5vw", '', false, "receiverBankName", bankDetails)}
                                                        </div> : null}
                                                    {paymentMethod === "isCheque" ?
                                                        <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5vw', flexWrap: 'wrap', marginTop: '0.5vw' }}>
                                                            {inputTextBox('chequeNo', states?.chequeNo, 'Cheque No', '12.5vw')}
                                                            {inputDatePicker('chequeDate', states?.chequeDate, 'Cheque Date', '12.5vw', '', '', 'chequeDateopen')}
                                                        </div> : null}
                                                </Box>
                                            </Box> : null}
                                        {states?.selectPayer === "Patient" ?
                                            <Box>
                                                <Box component={'div'}>
                                                    <FormControlLabel control={<Checkbox size='small' checked={states.isCash} onChange={(e) => PaymentCheckBox(e, 'isCash')} />} label="Cash" />
                                                    <FormControlLabel control={<Checkbox size='small' checked={states.isCard} onChange={(e) => PaymentCheckBox(e, 'isCard')} />} label="Card" />
                                                    <FormControlLabel control={<Checkbox size='small' checked={states.isUPI} onChange={(e) => PaymentCheckBox(e, 'isUPI')} />} label="UPI" />
                                                    <FormControlLabel control={<Checkbox size='small' checked={states.isBank} onChange={(e) => PaymentCheckBox(e, 'isBank')} />} label="Bank" />
                                                    <FormControlLabel control={<Checkbox size='small' checked={states.isCheque} onChange={(e) => PaymentCheckBox(e, 'isCheque')} />} label="Cheque" />
                                                </Box>
                                                <Box component={'div'}>
                                                    {states.isCash ? cashTextBox('cash_amt', states.cash_amt, 'Cash Amount', ImagePaths.CashIcon.default) : null}
                                                    {states.isCard ?
                                                        <Box component={'div'} display={'flex'}>
                                                            {cashTextBox('card_amt', states.card_amt, 'Card Amount', ImagePaths.CardIcon.default)}
                                                            {referenceTextBox('card_no', states.card_no)}
                                                        </Box> : null}
                                                    {states.isUPI ?
                                                        <Box component={'div'} display={'flex'}>
                                                            {cashTextBox('upi_amt', states.upi_amt, 'UPI Amount', ImagePaths.UPIIcon.default)}
                                                            {referenceTextBox('upi_no', states.upi_no)}
                                                        </Box> : null}
                                                    {states.isBank ?
                                                        <Box component={'div'} display={'flex'}>
                                                            {cashTextBox('bank_amt', states.bank_amt, 'Bank Amount', ImagePaths.BankTransferIcon.default)}
                                                            {referenceTextBox('bank_no', states.bank_no)}
                                                        </Box> : null}
                                                    {states.isCheque ?
                                                        <Box component={'div'} display={'flex'}>
                                                            {cashTextBox('cheque_amt', states.cheque_amt, 'Cheque Amount', ImagePaths.ChequeIcon.default)}
                                                            {referenceTextBox('cheque_no', states.cheque_no)}
                                                        </Box> : null}
                                                </Box>
                                            </Box> : null}
                                        <Box component={'div'} mt={'0.5vw'}>
                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={2}
                                                inputProps={{ maxLength: 500 }}
                                                label='Comments'
                                                value={states?.comments}
                                                onChange={(e) => setStates((prev) => ({ ...prev, comments: e.target.value }))}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </>
            );
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const TransactionHistoryScreen = () => {
        try {
            return (
                <>
                    {(amountDetail?.payment_status === 3 || amountDetail?.payment_status === null || !Editaccess) ? (
                        <Box component="div" height="31vw" p="0.5vw" display="flex" justifyContent="center" alignItems="center">
                            <Typography fontWeight={600}>
                                {!Editaccess ? "No Access To this user" : "No Transaction History To Be Shown"}
                            </Typography>
                        </Box>
                    ) : (
                        <Box component="div" height="31vw" p="0.5vw" display="flex">
                            <Box component="div" flex={1} border="1px solid lightgray" mr="0.5vw" overflow="auto">
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="14.28%" sx={tableHeadSx}>Bill Date</TableCell>
                                            <TableCell width="16.28%" sx={tableHeadSx}>Bill Details</TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>{`Bill AMT (${CurrencySymbol})`}</TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>{`Paid AMT (${CurrencySymbol})`}</TableCell>
                                            <TableCell width="14.28%" sx={tableHeadSx}>{`Outstanding (${CurrencySymbol})`}</TableCell>
                                            <TableCell width="16.28%" sx={tableHeadSx}>{`Detected (${CurrencySymbol})`}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {historytData?.length > 0 ? (
                                            historytData.map((item, index) => {
                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell>{formatDate(item?.invoice_date)}</TableCell>
                                                        <TableCell>
                                                            <Typography fontSize="0.8vw" fontWeight={600}>
                                                                {item?.invoice_number || 0}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>{AmountFormat(item?.net_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                        <TableCell>{AmountFormat(item?.received_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                        <TableCell>{AmountFormat(item?.outstanding_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                        <TableCell>{AmountFormat(item?.deduct_amount || 0)?.replace(CurrencySymbol, "")}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={7} align="center">No Records To Be Shown</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    )}
                </>
            );
        } catch (error) {
            errorMessage(error.message);
        }
    };

    let CompanyName = `${isForBulkPayment ? BulkDataStates?.company_name : (patientData?.insurance_company_name || patientData?.company_name || patientData?.employer_name || patientData?.insurance_name || '-')}`
    return (
        <Modal open={open} disableAutoFocus={true} disableEnforceFocus={true}>
            {isLoading ? <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", marginTop: "20vw" }}><CircularProgress /></div> :
                <Box id="emedhub_credit_popupBox_new" sx={{ width: isForBulkPayment ? '33vw' : "80vw"}}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" p="0.5vw" borderBottom="1px solid lightgray">
                        <Box sx={{ display:'flex', alignItems:'center'}}>
                            <Typography fontWeight={600}>{'Payment - '}</Typography>
                            <Typography fontWeight={600} marginLeft={"0.3vw"}>{ContentInTooltip(CompanyName, (isForBulkPayment ? 25 : 80), "0.9vw", 600)}</Typography>
                        </Box>
                        <Button emed_tid={"LabCloseButton_TestID"} onClick={() => { handleClose(); }} >
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                        </Button>
                    </Box>

                    {/* <Box display="flex" justifyContent="space-between" alignItems="center" p="0.5vw" borderBottom="1px solid lightgray">
                    <Box>
                        <Typography fontWeight={600}>{patientData?.insurance_company_name || '-'}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center">
                        {renderDatePicker()}
                        {inputTextBox('poDetailSearch', poDetailSearch, 'Search Bill Details', '15vw', '1vw')}
                        <Tooltip title="Search">
                            <IconButton sx={{ border: "1px solid #c3bfbf", borderRadius: "0.3vw", width: "2.3vw", height: "2.3vw", mr: '0.5vw' }} onClick={handleSearch}>
                                <SearchIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Clear">
                            <IconButton sx={{ border: "1px solid #c3bfbf", borderRadius: "0.3vw", width: "2.3vw", height: "2.3vw", mr: '0.5vw' }} onClick={handleClear}>
                                <ClearSharpIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                        {value !== 'one' && (
                            <Tooltip title="Print">
                                <IconButton>
                                    <Box component="img" src={ImagePaths.LabPrintIcon.default} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                </Box> */}

                    <Box>
                        <Box sx={{ display: isForBulkPayment ? 'none' : 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            {<Box sx={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: "space-between", width: '100%' }}>
                                {/* <Tabs value={value} onChange={handleTabChange}>
                                <Tab value="one" label="Outstanding Bills" className='eMed_tab_header eMed_bill_Tab' />
                                <Tab value="two" label="Transaction History" className='eMed_tab_header eMed_bill_Tab' />
                                </Tabs> */}
                                <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: "1vw" }}>
                                    <Box component={'div'} display={'flex'} alignItems={'center'} visibility={!ShowPHBills || states?.pharamacyList?.length <= 0 ? 'hidden' : "visible"}>
                                        {
                                            states?.pharamacyList?.map((item, index) => (
                                                <FormControlLabel control={<Checkbox size='small' checked={item?.pharmacy_id === states.include_pharmacy} onChange={(e) => {
                                                    setStates((prev) => ({ ...prev, include_pharmacy: states?.include_pharmacy === item?.pharmacy_id ? null : item?.pharmacy_id }))
                                                    handleClear();
                                                }} />} label={`${item?.pharmacy_name}`} />
                                            ))
                                        }
                                    </Box>
                                </Box>
                                <FormControl sx={{ width: '15vw', marginTop: "0.5vw", marginRight: "0.5vw" }} size='small'>
                                    <InputLabel id="group-select">{'Select Payer *'}</InputLabel>
                                    <Select
                                        labelId="group-select"
                                        id="demo-simple-select"
                                        value={states.selectPayer}
                                        label={'Select Payer'}
                                        onChange={(event) => {
                                            setStates((prev) => ({
                                                ...prev, selectPayer: event.target.value, tdsAmount: '',
                                                disallowanceAmt: '', hospitalConcess: '', payerBankName: '',
                                                payerAccountNo: '', transId: '', transDate: new Date(),
                                                receiverBankName: '', receiverAccountNo: '', transDateOpen: false,
                                                chequeNo: '', chequeDate: new Date(), chequeOpen: false,
                                                isCash: false, isCard: false, isUPI: false, isBank: false, isCheque: false,
                                                cash_amt: '', card_amt: '', card_no: '', upi_amt: '', upi_no: '', bank_amt: '',
                                                bank_no: '', cheque_amt: '', cheque_no: ''
                                            }));
                                            const updatedPaymentData = paymentData.map((item, i) => {
                                                const updatedItem = {
                                                    ...item,
                                                    is_checked: false,
                                                    deduct_amount: 0
                                                };
                                                return updatedItem;
                                            });
                                            setPaymentData(updatedPaymentData);
                                            setPayableAmount('')
                                            setReceivableAmt('')
                                            setPaymentMethod(null)
                                        }}
                                    >
                                        {type === "Insurance credit" ? <MenuItem value={"Insurance"}>{"Insurance"}</MenuItem> : null}
                                        {type === "Corporate credit" ? <MenuItem value={"Corporate"}>{"Corporate"}</MenuItem> : null}
                                        <MenuItem value={"Patient"}>{"Patient"}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>}
                        </Box>
                        {value === "one" ? OutstandingScreen() : value === "two" ? TransactionHistoryScreen() : null}
                    </Box>
                    {value === 'one' ?
                        <Box display="flex" justifyContent="flex-end" p="0.5vw" borderTop="1px solid lightgray">
                            <Button variant="outlined" style={{ textTransform: "capitalize" }} onClick={() => { handleClose() }}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                style={{ textTransform: "capitalize" }}
                                disabled={postLoad || !Editaccess || (+payableAmount <= 0) || (!states?.isCash && !states?.isCard && !states?.isUPI && !states?.isBank && !states?.isCheque && !paymentMethod) || (!states?.selectPayer)}
                                onClick={() => { isForBulkPayment ? handleBulkCreditPayment() : handleCreditPayment() }}
                                sx={{ ml: '1vw' }}
                            > Settle Credit </Button>
                        </Box> :
                        <Box display="flex" justifyContent="flex-end" p="0.5vw" borderTop="1px solid lightgray">
                            <Button variant="outlined" onClick={onClose}
                                disabled={amountDetail?.payment_status === 1 || amountDetail?.payment_status === null}>
                                Close
                            </Button>
                        </Box>}
                </Box>}
        </Modal>
    );
};

export default CreditPaymentPopup;
